import React from 'react';
import { Button } from './ui/button';
import { Twitter, Linkedin, Link as LinkIcon } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

/**
 * Share buttons for X, LinkedIn, and Copy Link.
 * The `text` is pre-filled for tweet/LinkedIn share; URL is canonical.
 */
const ShareButtons = ({ symbol, price, changePercent, trend }) => {
  const { toast } = useToast();
  if (!symbol) return null;

  const url = `${window.location.origin}/research?symbol=${encodeURIComponent(symbol)}`;
  const pctStr = changePercent != null ? `${changePercent >= 0 ? '+' : ''}${changePercent.toFixed(2)}%` : '';
  const priceStr = price != null ? `$${Number(price).toFixed(2)}` : '';
  const trendStr = trend ? ` | ${trend}` : '';
  const text = `Checking ${symbol} ${priceStr} (${pctStr})${trendStr} on Neon Alpha Investment Club`;

  const twitterHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
  const linkedinHref = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast({ title: 'Link copied', description: url });
    } catch {
      toast({ title: 'Copy failed', description: 'Please copy manually', variant: 'destructive' });
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <Button
        size="sm"
        variant="outline"
        onClick={() => window.open(twitterHref, '_blank', 'noopener,noreferrer')}
        data-testid="share-x-btn"
      >
        <Twitter size={14} className="mr-1" /> X
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={() => window.open(linkedinHref, '_blank', 'noopener,noreferrer')}
        data-testid="share-linkedin-btn"
      >
        <Linkedin size={14} className="mr-1" /> LinkedIn
      </Button>
      <Button size="sm" variant="outline" onClick={copy} data-testid="share-copy-btn">
        <LinkIcon size={14} className="mr-1" /> Copy
      </Button>
    </div>
  );
};

export default ShareButtons;
